import React from "react";
import { connect } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { styled } from "@mui/material";

//website pages
import Error from "../pages/error/";
import Login from "../pages/login";
import ForgotPassword from "../pages/forgotPassword";

import AuthWrapper from "../components/AuthWrapper";


// Define Props Interfaces
interface LayoutProps {
    children: React.ReactNode;
}

interface MainProps {
    children: React.ReactNode;
}


// AuthLayout Component
function AuthLayout(props: any) {
    return (
                <AuthWrapper>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path='/forgot-password' element={<ForgotPassword/>}  />
                    <Route path="/*" element={<Error />} > </Route>
                </Routes>

                </AuthWrapper>
    );
}

const mapStateToProps = (state: any) => ({
    sideNavState: state.layout.sideNavOpen,
});

const mapDispatchToProps = (dispatch: any) => ({
    // Map your Redux dispatch actions here if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthLayout);
